import classNames from "classnames";
import { Link } from "react-router-dom";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { UGGLogoFull } from "@ugitgud/legos/ui/icon/UGGLogoFull";
import { UGGLogo } from "@ugitgud/legos/ui/icon/UGGLogo";
import { SvgMiscPlus } from "@ugitgud/legos/ui/icon/SVG/MiscPlus";
import { SvgUggPlusOverlay } from "@ugitgud/legos/ui/icon/SVG/UggPlusOverlay";
import { AppRoutes } from "@ugg/shared/routes/app-routes";

const PLUS_EXTERNAL_URL = "https://u.gg/plus?utm_source=uggtierlist";

interface TierListCTABannerProps {
  className?: string;
  inNewWindow?: boolean;
}

export function TierListCTABanner({ className, inNewWindow }: TierListCTABannerProps) {
  return (
    <div
      className={classNames(
        "relative flex items-center justify-between gap-4 w-full h-[54px] pl-[17px] pr-3 rounded border border-[#32326E] overflow-hidden backdrop-blur-[1px]",
        className,
      )}
      style={{
        backgroundImage:
          "radial-gradient(circle, rgba(24, 248, 235, 0.3) 0%, rgba(24, 248, 235, 0.15) 30%, rgba(24, 248, 235, 0.02) 100%)",
      }}
    >
      <div
        className="absolute inset-0 pointer-events-none overflow-hidden z-0 opacity-[0.14]"
        style={{
          maskImage: "linear-gradient(90deg, rgba(0,0,0,0) 0%, #000 20%, #000 80%, rgba(0,0,0,0) 100%)",
          WebkitMaskImage: "linear-gradient(90deg, rgba(0,0,0,0) 0%, #000 20%, #000 80%, rgba(0,0,0,0) 100%)",
        }}
      >
        <div className="w-[150%] -ml-[25%] -mt-[150px]">
          <Icon icon={<SvgUggPlusOverlay />} className="w-full h-auto text-[#C8AC70]" />
        </div>
      </div>

      <div className="relative z-[1] flex items-center gap-2 shrink-0">
        <div className="hidden sm:block h-5 w-[62px] shrink-0">
          <UGGLogoFull />
        </div>
        <div className="block sm:hidden h-5 w-[15px] shrink-0">
          <UGGLogo />
        </div>
        <span className="inline-flex items-center rounded text-[11px] font-bold leading-none border border-accent-yellow-400 px-1.5 py-1 bg-accent-brown-400 text-accent-yellow-400">
          PLUS
        </span>
      </div>
      <p className="relative z-[1] flex-1 text-white text-[16px] font-barlow-condensed !font-medium uppercase tracking-wide text-center pointer-events-none whitespace-nowrap">
        <span className="hidden xs:inline">Upgrade now to unlock your own </span>
        <span className="inline xs:hidden">Unlock your </span>
        <span className="text-accent-yellow-400">Personal Tier List</span>
      </p>
      <Link
        to={`${AppRoutes.PLUS}?utm_source=uggtierlist`}
        onClick={
          inNewWindow
            ? (e) => {
                e.preventDefault();
                window.open(PLUS_EXTERNAL_URL);
              }
            : undefined
        }
        className="group relative z-[1] flex items-center justify-center w-[28px] sm:w-[150px] h-[28px] sm:h-[30px] p-[5px] sm:p-0 rounded-none sm:rounded text-[13px] font-semibold text-white bg-accent-brown-400 border border-accent-yellow-400 whitespace-nowrap shrink-0"
      >
        <span
          className="absolute inset-0 rounded-none sm:rounded opacity-0 group-hover:opacity-100 transition-opacity"
          style={{ background: "linear-gradient(0deg, rgba(244, 200, 116, 0.05) 0%, rgba(244, 200, 116, 0.05) 100%), #25254B" }}
        />
        <SvgMiscPlus className="relative block sm:hidden text-accent-yellow-400 w-4 h-4" />
        <span className="relative hidden sm:inline">
          Start Your&nbsp;<span className="text-accent-yellow-400 font-bold">Free</span>&nbsp;Trial
        </span>
      </Link>
    </div>
  );
}
